import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  standalone: false
})
export class EmptyStateComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() showReloadHint: boolean = false;
  @Input() showImage: boolean = false;
}
